<template>
    <div class="modal__filter_item">
        <div class="modal__filter_item_wrapper">
            <div class="modal__filter_item_title">
                <span class="modal__filter_item_title_text">{{ itemText }}</span>
            </div>
            <div class="modal__filter_item_checkbox" @click.prevent="clickCheck">
                <svg>
                    <use :xlink:href="'/icons/base.svg#' + checkState"></use>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "modal",
    props: {
        filterItem: {
            type: Object,
            required: true,
        },
        nameOperation: {
            type: String,
            required: true,
            default: ''
        },

    },
    emits: ['click_check'],
    methods: {
        clickCheck() {
            if(this.nameOperation === 'modal_filter'){
                this.filterItem.isCheck = !this.filterItem.isCheck;
            } else if(this.nameOperation === 'modal_product_locations'){
                this.filterItem.isCheckProductStopList = !this.filterItem.isCheckProductStopList;
            }
        }
    },
    computed: {
        checkState() {
            if(this.nameOperation === 'modal_filter' && this.filterItem.isCheck){
                return 'mark';
            } else if(this.nameOperation === 'modal_product_locations' && this.filterItem.isCheckProductStopList){
                return 'mark';
            }
            return 'unmark';
        },
        itemText() {
            return this.filterItem.title;
        },
        itemId() {
            return this.filterItem.uniq_id;
        }
    },
    watch: {}
}
</script>
